export default {"src":"/_next/static/media/curved-items-landing-3.9bd90607.svg","height":60,"width":60,"blurWidth":0,"blurHeight":0};